/* import __COLOCATED_TEMPLATE__ from './fast-edit.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();